import React from "react";
import { withStyles } from "@material-ui/core/styles";

import {
  Datagrid,
  List,
  ShowButton,
  TextField,
  DateField,
  EditButton,
  TextInput,
  SelectInput,
} from "react-admin";

import { MyListActions } from "../__common/MyListActions";
import { MyListPagination } from "../__common/MyListPagination";

const styles = (theme) => ({
  title: {
    maxWidth: "20em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});

const filters = [
  <TextInput label="Search" source="code" alwaysOn />,
  <TextInput label="Sample" source="sample" />,
  <TextInput label="Description" source="description" />,
  <SelectInput
    source="source"
    choices={[
      { id: "Water", name: "Water" },
      { id: "Environment", name: "Environment" },
      { id: "Health Facilities", name: "Health Facilities" },
      { id: "Other", name: "Other" },
    ]}
  />,
  <TextInput label="Sampling site" source="sampling_site" />,
  <TextInput label="Notes" source="notes" />,
];

export const SamplesList = withStyles(styles)(({ classes, ...props }) => (
  <List
    {...props}
    filters={filters}
    actions={<MyListActions />}
    sort={{ field: "code", order: "ASC" }}
    pagination={<MyListPagination />}
    perPage={100}
  >
    <Datagrid>
      <TextField label="Sample code" source="code" />
      {/* <TextField source="sample" /> */}
      <DateField
        source="collection_date"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
      />
      <TextField source="description" />
      {/* <NumberField source="longitude" />
        <NumberField source="latitude" /> */}
      <TextField source="source" />
      <TextField source="sampling_site" />
      <TextField source="notes" />

      <DateField
        source="createdAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      <DateField
        source="updatedAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      <EditButton />
      <ShowButton />
    </Datagrid>
  </List>
));
